import { ExternalAccounts } from '../../../member-profile/components/ExternalAccounts';

export default function ExternalAccountsScreen() {
    return <ExternalAccounts />;
}
